'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const body2ClassNames = {
  root: 'fui-Body2'
};
/**
 * Styles for the root slot
 */
export const useBody2Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fod5ikn",
    Bhrd7zp: "figsok6",
    Bg96gwp: "faaz57k"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".faaz57k{line-height:var(--lineHeightBase400);}"]
});